/**
 * 联系方式配置
 */
export const contactConfig = {
  // 显示开关
  showDomestic: true, // 国内联系方式（微信、微信群、售后群、温馨提示）
  showOverseas: true, // 海外联系方式（Discord）

  // 客服微信号
  wechatId: 'yxaichat',

  // 企业客服专员微信号
  enterpriseWechatId: 'G10246688',
  // discord在线频道
  discord: 'https://discord.gg/VuPSjXJn3V',

  // 二维码图片路径
  images: {
    customerService: '   https://ccnetcore.com/prod-api/wwwroot/aihub/wx.png ', // 客服微信二维码
    communityGroup: ' https://ccnetcore.com/prod-api/wwwroot/aihub/jlq_yxai.png', // 交流群二维码
    afterSalesGroup: '', // 售后群二维码
    enterpriseService: '   https://ccnetcore.com/prod-api/wwwroot/aihub/wx_qykf.png ', // 企业客服专员二维码
  },
};

/**
 * 淘宝店铺配置
 */
export const taobaoConfig = {
  // 淘宝店铺链接
  link: 'https://item.taobao.com/item.htm?ft=t&id=1042468047396',

  // 淘口令
  code: '【淘宝】https://e.tb.cn/h.RZOKX46z9Mqhomr?tk=CkLX5Kc8yQW HU287 「ClaudeCode/Codex/Gemini Ai聚合API服务/Token源头工厂/人工售后」\n'
    + '点击链接直接打开 或者 淘宝搜索直接打开',
  taobaoQr: 'https://ccnetcore.com/prod-api/wwwroot/aihub/yx_taobao.png', // 淘宝商品二维码

};

/**
 * 套餐提示配置
 */
export const promotionConfig = {
  // VIP套餐说明
  vipPackageTip: '开通 VIP 后即可使用 VIP 模型',

  // 尊享积分说明
  tokenPackageTip: '购买尊享积分后即可使用尊享模型',

  // 通用客服说明
  serviceTip: '购买、API接入、模型选型或售后问题可联系客服协助处理',
};

/**
 * 新手引导配置
 */
export const guideTourConfig = {
  // 注册后多少小时内登录会自动弹出新手引导
  newUserHours: 24,
};
